import React from 'react'

import { SvgProps } from './types'

function Pin3Svg({ width, height, className, stroke, strokeColor }: SvgProps) {
  return (
    <svg
      width={width || '40'}
      height={height || '40'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      strokeWidth={stroke || 1.6}
      stroke="currentColor"
      fill="none"
      className={className}
      strokeMiterlimit={10}
    >
      <path
        d="M7.91667 12.0833L2.5 17.5"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16721 7.90408L11.8275 15.5644L13.2417 14.1502L12.915 10.995L17.5059 7.10059L12.6311 2.22585L8.73662 6.81663L5.58143 6.48986L4.16721 7.90408Z"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Pin3Svg
